import { QueryClient } from '@tanstack/react-query'
import { fetchPage } from '@vangst/services/oogst/page'
import { RobotsEnum } from '@vangst/services/oogst/types'
import Routes from '@vangst/services/routes'
import { InferGetStaticPropsType } from 'next'
import Breadcrumbs from '../../components/navigation/Breadcrumbs'
import ClickyLink from '../../components/navigation/ClickyLink'
import PageHeader from '../../components/views/PageHeader'
import Meta from '../../domains/application/Meta'

export async function getStaticProps() {
  const routes = Object.keys(Routes)
    ?.filter((route: string) => route.toLowerCase().includes('legal'))
    .filter((route: string) => route !== 'LEGAL')

  const queryClient = new QueryClient()
  const rawUrl = __filename.split('pages')[1]?.replace('.js', '')
  const { getPage } = await fetchPage(queryClient, { rawUrl })
  const page = { ...getPage, title: getPage?.title ?? 'Vangst Legal' }
  const crumbs = [
    { href: Routes.INDEX, text: 'Home' },
    { href: null, text: 'Legal' },
  ]

  return {
    props: { crumbs, page, routes },
    revalidate: 30,
  }
}

// -------------------------------------

type PropsType = InferGetStaticPropsType<typeof getStaticProps>

export default function Legal(props: PropsType) {
  const { crumbs, page, routes } = props
  return (
    <>
      <Meta
        key="meta"
        canonicalUrl={page.metaInfo?.canonicalUrl}
        crumbs={crumbs}
        description={page.metaInfo?.description}
        image={page.pagePhotos?.[0]?.url}
        publishDate={page.postedAt}
        robots={page.metaInfo?.robots ?? RobotsEnum.IndexFollow}
        title={
          page.metaInfo?.title ??
          'Legal links for Cannabis Industry Jobs, Education, Reports and Information'
        }
      />
      <Breadcrumbs crumbs={crumbs} />
      <article className="mood-white">
        <PageHeader
          title={page.title}
          subtitle={page.subtitle}
          description={page.description}
          imgAlt={page.pagePhotos?.[0]?.alt}
          imgSrc={page.pagePhotos?.[0]?.url}
        />
        <section className="contain-xyc">
          <ul className="flow-y-xs">
            {routes.map((route: string) => (
              <li key={route}>
                <ClickyLink
                  className="link-blue-dark capitalize underline"
                  href={Routes[route as keyof typeof Routes]}
                >
                  &raquo; {route?.toLowerCase().split('_').slice(1).join(' ')}
                </ClickyLink>
              </li>
            ))}
          </ul>
        </section>
      </article>
    </>
  )
}
